import axiosInstance from './axiosInstance';

export interface CreateFeedbackPayload {
  feedbackText: string;
}

export interface Feedback {
  _id: string;
  userId: string;
  feedbackText: string;
  createdAt: string;
}

export interface UserForFeedback {
  _id: string;
  email: string;
  username: string;
}

export interface FeedbackWithUser {
  _id: string;
  feedbackText: string;
  userId: UserForFeedback;
  createdAt: string;
}

export const feedbackApi = {
  submitFeedback: async (payload: CreateFeedbackPayload) => {
    const response = await axiosInstance.post('/feedback', payload);
    return response.data;
  },

  checkRecentFeedback: async (): Promise<boolean> => {
    const response = await axiosInstance.get('/feedback/recent');
    return response.data !== null;
  },

  getAllFeedbackWithUsers: async (): Promise<FeedbackWithUser[]> => {
    const response = await axiosInstance.get('/feedback');
    return response.data;
  },
};